import React from "react";
import { BarChart } from "react-feather";

export default function PatientHeader({ subjectName, bg, subheader, showIcon = true }) {
  // Define the fixed width for the icon container and an extra margin
  const iconWidth = 24; // e.g., 24px
  const iconMargin = 8; // e.g., 8px

  return (
    <header className={`page-header page-header-light pb-10${bg ? " " + bg : ""}`}>
      <div className="container-xl px-4">
        <div className="page-header-content pt-4">
          <div className="row align-items-center">
            <div className="col-auto mt-4">
              <div className="d-flex align-items-center">
                {/* Icon placeholder: always reserve the same space */}
                <div style={{ width: `${iconWidth}px`, marginRight: `${iconMargin}px` }}>
                  {showIcon && <BarChart className="page-header-icon" />}
                </div>
                <h1 className="page-header-title mb-0">
                  {subjectName || ""}
                </h1>
              </div>
              {/* Subheader on the next line, aligned with header text */}
              {subheader && (
                <div className="page-header-subtitle" style={{ marginLeft: `${iconWidth + iconMargin}px` }}>
                  {subheader}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
